import cn from 'classnames';
import { FooterBackgroundColor } from './Footer.types';

type BottomSectionProps = {
  backgroundColor: FooterBackgroundColor;
  children: React.ReactNode[];
}

export const BottomSection = ({ backgroundColor, children }: BottomSectionProps) => (
  <div
    className={cn('px-container-mobile md:px-container-desktop py-5', {
      'bg-violet-900 text-violet-200': backgroundColor === 'violet',
    })}
  >
    <div className="mx-auto max-w-grid">
      {children}
    </div>
  </div>
)
